import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const BASE_URL = process.env.REACT_APP_SITE_URL || 'https://newcrochet.store';

const SUPPORTED_LANGUAGES = ['en', 'de', 'fr', 'es', 'pt'] as const;

export const SEO = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const getUrlForLang = (lang: string) => {
    return lang === 'en' ? `${BASE_URL}/` : `${BASE_URL}/${lang}/`;
  };

  const canonicalUrl = getUrlForLang(currentLang);
  const title = t('seo.title');
  const description = t('seo.description');

  return (
    <Helmet>
      <html lang={currentLang} />
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      <link rel="canonical" href={canonicalUrl} />

      {SUPPORTED_LANGUAGES.map((lang) => (
        <link
          key={lang}
          rel="alternate"
          hrefLang={lang}
          href={getUrlForLang(lang)}
        />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${BASE_URL}/`} />

      {/* Open Graph */}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

      {/* Twitter */}
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};
